"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function EyeCrossed16Svg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "16px", height: "16px", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { d: "M14.9982032,8 C14.0314953,10.9035742 11.262841,13 7.99820323,13 C6.96556723,13 5.98255521,12.790249 5.0904974,12.4115492 L7.56601437,10.9830381 C7.70877364,10.9942802 7.85291902,11 7.99820323,11 C10.102623,11 11.9681036,9.79992596 12.8431606,8 L12.817,7.95 L14.5523402,6.94876496 C14.7275562,7.28480337 14.8770345,7.63606132 14.9982032,8 Z M7.99820323,3 C9.60128986,3 11.084782,3.50550272 12.2940486,4.36385268 L14.4264065,3.1339746 L15.4264065,4.8660254 L1.57,12.8660254 L0.57,11.1339746 L2.18795421,10.1989002 C1.67170072,9.54606285 1.26587572,8.80397285 0.99820323,8 C1.96491116,5.09642582 4.7335655,3 7.99820323,3 Z M7.99820323,5 C5.89378347,5 4.02830288,6.20007404 3.15324584,8 C3.36354631,8.4325721 3.63105107,8.83049831 3.945329,9.18544711 L5.99820348,7.9989959 C5.99874593,6.8948879 6.89396845,6 7.99820323,6 L7.99820323,6 L7.998,6.844 L10.3069308,5.51206492 C9.60342816,5.18255923 8.8189898,5 7.99820323,5 Z", id: `eyecrossed16-${id0}` })),
        react_1.default.createElement("g", { id: "eye-crossed-16", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("mask", { id: "mask-2", fill: "white" },
                react_1.default.createElement("use", { xlinkHref: `#eyecrossed16-${id0}` })),
            react_1.default.createElement("use", { id: "Combined-Shape", fill: "#000000", fillRule: "nonzero", xlinkHref: `#eyecrossed16-${id0}` })));
}
function EyeCrossed16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(EyeCrossed16Svg, Object.assign({}, svgProps)));
}
exports.default = EyeCrossed16;
//# sourceMappingURL=EyeCrossed16.js.map